const LOCALE = 'fr-FR';
const INNER_SPACES = /\s+/g;
const WORD_START = /(^|[\s'’-])\p{L}/gu;

const collapseSpaces = (text: string) => text.trim().replace(INNER_SPACES, ' ');

// The case of a last name, applicable while typing: capital letters, accents
// kept.
export const toLastNameCase = (text: string): string =>
  text.toLocaleUpperCase(LOCALE);

// The case of a first name, applicable while typing: a capital initial for
// each part (after a space, a hyphen or an apostrophe).
export const toFirstNameCase = (text: string): string =>
  text
    .toLocaleLowerCase(LOCALE)
    .replace(WORD_START, (start) => start.toLocaleUpperCase(LOCALE));

// « de La Fontaine » becomes « DE LA FONTAINE ».
export const normalizeLastName = (lastName: string): string =>
  toLastNameCase(collapseSpaces(lastName));

// « jean-pierre » becomes « Jean-Pierre »; a blank first name is absent.
export const normalizeFirstName = (
  firstName: string | null | undefined,
): string | null => toFirstNameCase(collapseSpaces(firstName ?? '')) || null;
